// Opaque, DO-issued guest token for public/external apps. Unlike the old scheme (browser picks its
// own guest id), the DO generates the id and hands back this token (the secret); the browser only
// stores and replays it. Sent as x-vibe-guest-token; the server resolves it to guest:<id> via the
// DO. Because the id is DO-owned, a guest id seen in presence can't be impersonated without the
// matching token. Members ignore this (they resolve via the monday session).
const KEY = 'vibeGuestToken';

// In-memory mirror so the token stays stable for the session even when localStorage is blocked
// (private mode / disabled storage) — avoids re-minting a new identity on every call.
let cached: string | undefined;

export function getStoredGuestToken(): string | undefined {
  if (cached) return cached;
  if (typeof window === 'undefined') return undefined;
  try {
    cached = window.localStorage.getItem(KEY) ?? undefined;
  } catch {
    // localStorage blocked — nothing persisted yet; caller will mint and setStoredGuestToken().
  }
  return cached;
}

export function setStoredGuestToken(token: string): void {
  cached = token; // session-stable even if the write below throws
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    // localStorage blocked — identity survives via `cached` until reload.
  }
}
